import { Smartphone, Wallet, ShieldCheck } from "lucide-react";
import { Card } from "../components/ui/Card";

export default function Payout() {
  return (
    <div className="overflow-hidden">
      {/* Hero */}
      <section className="relative bg-slate-900 text-white">
        <div
          aria-hidden
          className="pointer-events-none absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-primary/25 blur-[120px]"
        />
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 sm:py-24">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-foreground/90 backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            Get paid, on your terms
          </span>
          <h1 className="mt-5 font-montserrat text-3xl font-bold leading-tight sm:text-5xl">
            Payouts
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base text-slate-300 sm:text-lg">
            Your business has a SHUWA wallet. Withdraw to mobile money anytime, for 300 RWF per withdrawal.
          </p>
        </div>
      </section>

      {/* Your wallet */}
      <section className="mx-auto -mt-10 max-w-5xl px-4 pb-16 sm:px-6 sm:pb-24">
        <div className="text-center">
          <h2 className="font-montserrat text-2xl font-bold text-slate-900 sm:text-3xl">
            Your Money, When You Want It
          </h2>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <Card className="p-6 sm:p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Wallet className="h-6 w-6" />
            </div>
            <h3 className="mt-4 font-montserrat text-lg font-bold text-slate-900">
              Your SHUWA wallet
            </h3>
            <p className="mt-1 text-sm font-medium text-primary">
              Included with every business account
            </p>
            <p className="mt-3 text-sm font-semibold text-slate-900">Balance grows as you get paid</p>
            <p className="mt-1 text-sm text-muted-foreground">
              What your customers pay online is held securely in your wallet and released to your balance once each appointment is completed.
            </p>
          </Card>

          <Card className="p-6 sm:p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Smartphone className="h-6 w-6" />
            </div>
            <h3 className="mt-4 font-montserrat text-lg font-bold text-slate-900">
              Withdraw anytime
            </h3>
            <p className="mt-1 text-sm font-medium text-primary">
              MTN Mobile Money • Airtel Money
            </p>
            <p className="mt-3 text-sm font-semibold text-slate-900">
              300 RWF per withdrawal
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              Send your balance to your mobile money number whenever you like. The fee is shown before you confirm.
            </p>
          </Card>
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 text-sm font-semibold text-slate-900">
          <ShieldCheck className="h-4 w-4 text-primary" />
          Simple. Secure. Anytime.
        </div>
      </section>
    </div>
  );
}
